import { PieChart, Pie, Cell, Legend } from "recharts";
import { useEffect, useState } from "react";
import { digitsEnToFa } from "@persian-tools/persian-tools";
interface tableProps {
  dataProps: any;
}

const COLORS = ["#F44177", "#AA4CB3", "#005FBE"];

const ChartOrder = ({ dataProps }: tableProps) => {
  const [dataTable, setDataTable] = useState<any>([]);

  useEffect(() => {
    if (
      dataProps &&
      dataProps.entreeCount >= 0 &&
      dataProps.etcCount >= 0 &&
      dataProps.sideCount >= 0
    ) {
      const total =
        dataProps.entreeCount + dataProps.etcCount + dataProps.sideCount;
      setDataTable(
        total > 0
          ? [
              {
                name: "غذای اصلی",
                value: Math.round((dataProps.entreeCount / total) * 100),
                color: "#F44177",
                fill: "#F44177",
              },
              {
                name: "کنار غذا",
                value: Math.round((dataProps.sideCount / total) * 100),
                color: "#AA4CB3",
                fill: "#AA4CB3",
              },
              {
                name: "سایر",
                value: Math.round((dataProps.etcCount / total) * 100),
                color: "#005FBE",
                fill: "#005FBE",
              },
            ]
          : []
      );
    }
  }, [dataProps]);

  return (
    <div className="flex items-center w-full flex-row-reverse pe-4">
      <PieChart width={220} height={220}>
        <Pie
          data={dataTable}
          cx="50%"
          cy="50%"
          innerRadius={80}
          outerRadius={110}
          paddingAngle={0}
          dataKey="value"
        >
          {dataTable.map((entry: any, index: any) => (
            <>
              <span className="hidden">{entry}</span>
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            </>
          ))}
        </Pie>
      </PieChart>
      <Legend />
      <div className="flex space-x-6 w-full justify-between flex-col gap-4">
        {dataTable &&
          dataTable.length > 0 &&
          dataTable.map((entry: any, index: any) => (
            <div key={index} className="flex items-center space-x-1 gap-2 ">
              <span
                className="w-[14px] h-[14px] rounded-sm"
                style={{ backgroundColor: entry.fill }}
              ></span>

              <span className="text-sm font-medium">{entry.name}</span>
              <span className="text-sm text-gray-500 text-primary-300">
                {digitsEnToFa(entry.value)}%
              </span>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ChartOrder;
